<template>
  <el-dialog :title="$t('newApp.Customers.ac')" :visible.sync="dialogVisible" width="1200px" class="addTraderDialog"
    @close="dialogCloseHandle" v-loading="loadingdialog">
    <div class="ordinaryMode common_contentBox" v-show="modeSwitch">
      <div class="common_search">
        <el-row>
          <el-col :span="8">
            <div class="label">{{ $t('newApp.Customers.CustomerName') }}</div>
            <div class="content">
              <el-input v-model="form.clientName" @keyup.enter.native="searchBtn" :placeholder="$t('general.pec')" />
            </div>
          </el-col>
          <el-col :span="8">
            <div class="label">{{ $t('newApp.ADList.Province') }}</div>
            <div class="content">
              <el-input v-model="form.province" @keyup.enter.native="searchBtn" :placeholder="$t('general.pec')" />
            </div>
          </el-col>
          <el-col :span="8">
            <div class="label">{{ $t('newApp.ADList.City') }}</div>
            <div class="content">
              <el-input v-model="form.city" @keyup.enter.native="searchBtn" :placeholder="$t('general.pec')" />
            </div>
          </el-col>
          <el-col :span="8">
            <div class="label">{{ $t('newApp.ADList.Sales') }}</div>
            <div class="content">
              <el-input v-model="form.salerName" @keyup.enter.native="searchBtn" :placeholder="$t('general.pec')" />
            </div>
          </el-col>
          <el-col :span="8">
            <div class="label">{{ $t('newApp.ADList.Industry') }}</div>
            <div class="content">
              <el-input v-model="form.industry" @keyup.enter.native="searchBtn" :placeholder="$t('general.pec')" />
            </div>
          </el-col>
          <el-col :span="8" />
          <div class="btnBar">
            <el-button plain @click="resetBtn">{{ $t('btn.Reset') }}</el-button>
            <el-button type="primary" @click="searchBtn">{{ $t('btn.Search') }}</el-button>
          </div>
        </el-row>
      </div>
      <commonTable ref="addTraderTable" :data-filter-method="dataFilterMethod">
        <template #buttons>
          <el-button type="primary" :disabled="batchAddDisabled" @click="batchAddHandle">{{ $t('btn.BatchAdd') }}</el-button>
        </template>
      </commonTable>
    </div>
    <div class="customMode" v-show="!modeSwitch">
      <div class="link" @click="companyQueryBtn">
        <img src="@/assets/images/tinyanchalogo.png">
        <span>{{ $t('newApp.Customers.tctftrcn') }}</span>
      </div>
      <el-form class="common_form" label-position="left" ref="addTraderForm" :rules="rules" label-width="150px"
        :model="formData">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('newApp.ADList.CustomerUnit')" prop="clientName">
              <!-- <el-input v-model="formData.clientName" /> -->
              <el-select v-model="formData.clientName" allow-create filterable remote :placeholder="$t('general.peak')"
                :remote-method="remoteMethod" :loading="loading" @change="clientNameChange">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('newApp.Customers.ci')" prop="isChannel">
              <el-select v-model="formData.isChannel" :placeholder="$t('general.ps')" @change="identityChange">
                <el-option v-for="(item, index) in isChannelList" :key="index" :label="item" :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12" v-if="formData.isChannel === $t('general.Client')">
            <el-form-item :label="$t('newApp.Customers.bo')" prop="opportunityName">
              <el-select v-model="formData.opportunityName" clearable :placeholder="$t('general.ps')" filterable
                @change="opportunityNameChange">
                <el-option v-for="(item, index) in businessList" :key="index" :label="item.opportunityName"
                  :value="item.opportunityName" />
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item :label="$t('newApp.Customers.ccon')" prop="name">
              <el-input v-model="formData.name" />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.isChannel === $t('general.Channel')">
            <el-form-item :label="$t('newApp.Customers.cst')" prop="channelContractType">
              <el-input v-model="formData.channelContractType" />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.isChannel === $t('general.Channel')">
            <el-form-item :label="$t('newApp.Customers.wtb')" prop="coconstructionOrNot">
              <el-select v-model="formData.coconstructionOrNot" :placeholder="$t('general.ps')">
                <el-option :label="$t('newApp.Customers.cb')" :value="$t('newApp.Customers.cb')" />
                <el-option :label="$t('newApp.Customers.ncc')" :value="$t('newApp.Customers.ncc')" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('eventList.Position')">
              <el-input v-model="formData.position" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('newApp.ADList.ContactNumber')" prop="phone">
              <el-input v-model="formData.phone" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('newApp.ADList.Email')" prop="email">
              <el-input v-model="formData.email" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('newApp.ADList.SalerName')">
              <el-input v-model="formData.salerName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('newApp.Customers.isyxq')" prop="needType">
              <el-select v-model="formData.needType" allow-create remote :placeholder="$t('general.peak')"
                :loading="loading" @change="needTypeChange">
                <el-option v-for="item in needTypeList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="formData.needType && formData.needType !== '0'">
            <el-form-item :label="$t('newApp.Customers.khxq')" prop="needChoose">
              <el-checkbox-group v-model="formData.needChoose">
                <el-checkbox :label="item.needId" v-for="item in needChooseList" :key="item.needId">{{ item.need
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.needType && formData.needType !== '0'">
            <el-form-item :label="$t('newApp.ADList.Area')" prop="area">
              <el-select v-model="formData.area" allow-create remote :placeholder="$t('general.ps')" clearable
                :loading="loading">
                <el-option v-for="item in areaList" :key="item.id"
                  :label="lang === 'zh-CN' ? item.fieldValue : item.fieldValueEn"
                  :value="lang === 'zh-CN' ? item.fieldValue : item.fieldValueEn" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.needType && formData.needType !== '0'">
            <el-form-item :label="$t('newApp.ADList.Industry')" prop="industry">
              <el-select v-model="formData.industry" allow-create remote :placeholder="$t('general.ps')" clearable
                :loading="loading">
                <el-option v-for="item in industryList" :key="item.id"
                  :label="lang === 'zh-CN' ? item.fieldValue : item.fieldValueEn"
                  :value="lang === 'zh-CN' ? item.fieldValue : item.fieldValueEn" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="formData.needType && formData.needType !== '0'">
            <el-form-item :label="$t('newApp.ADList.xqcp')" prop="needProduct">
              <el-checkbox-group v-model="formData.needProduct">
                <el-checkbox :label="lang === 'zh-CN' ? item.fieldValue : item.fieldValueEn"
                  v-for="item in needProductList" :key="item.id">
                  {{ lang === 'zh-CN' ? item.fieldValue : item.fieldValueEn }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="formData.needType && formData.needType !== '0'">
            <el-form-item :label="$t('newApp.ADList.xpms')" prop="needNote">
              <el-input type="textarea" :rows="2" :placeholder="$t('general.pec')" v-model="formData.needNote" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('newApp.ADList.InviteSourceName')">
              <el-radio-group v-model="formData.inviteSource">
                <el-radio v-for="item in inviteSourceList" :label="item.fieldKey" :key="item.fieldKey">{{ item.fieldValue }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer" v-show="!modeSwitch">
      <el-button v-if="!editFlage" @click="customCancelHandle">{{ $t('btn.Cancel') }}</el-button>
      <el-button type="primary" :disabled="customAddDisabled" @click="customAddHandle">{{ $t('btn.OK') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import commonTable from 'components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import { travellingTrader } from '../../../service';
import { waitingProcessingApi } from '@/views/privateSeaPool/service';
import { newApplicationFormApi } from '@/views/newApplicationForm/service';
import { isNotEmpty } from '../../../../../utils/utils';
import { confirmPrecheck, confirmBusiness, notifyDetectFailed } from '@/utils/exportComplianceDialog';
export default {
  data() {
    let phoneNumberValidator = (rule, value, callback) => {
      // if (value && !/^[0-9]{7,}$/.test(value)) {
      //   callback(new Error(this.$t('newApp.BasicInfo.pnfiw')));
      // } else {
      //   callback();
      // }
      callback()
    };
    return {
      rules: {
        clientName: [
          { required: true, message: this.$t('newApp.Customers.Pecu'), trigger: 'blur' }
        ],
        isChannel: [
          { required: true, message: this.$t('newApp.Customers.psci'), trigger: 'change' }
        ],
        opportunityName: [
          { required: false, message: this.$t('newApp.Customers.peabon'), trigger: 'change' }
        ],
        name: [
          { required: true, message: this.$t('newApp.Customers.pecc'), trigger: 'blur' }
        ],
        channelContractType: [
          { required: false, message: this.$t('newApp.Customers.pecst'), trigger: 'blur' }
        ],
        coconstructionOrNot: [
          { required: false, message: this.$t('newApp.Customers.pswtb'), trigger: 'change' }
        ],
        phone: [
          { required: true, message: this.$t('newApp.Customers.psfiw'), trigger: 'blur' },
          { required: true, validator: phoneNumberValidator, trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: this.$t('newApp.Customers.Petcea'), trigger: 'blur' }
        ],
        entityType: [
          { required: true, message: this.$t('newApp.Customers.psacc'), trigger: 'change' }
        ],
        needType: [
          { required: true, message: this.$t('newApp.Customers.psacc'), trigger: 'change' }
        ],
        needChoose: [
          { type: 'array', required: true, message: this.$t('newApp.Customers.pscr'), trigger: 'change' }
        ],
        area: [
          { required: false, message: this.$t('general.ps'), trigger: 'change' }
        ],
        industry: [
          { required: false, message: this.$t('general.ps'), trigger: 'change' }
        ],
        needProduct: [
          { required: false, message: this.$t('general.ps'), trigger: 'change' }
        ],
        needNote: [
          { required: false, message: this.$t('general.pec'), trigger: 'change' }
        ]
      },
      dialogVisible: false,
      modeSwitch: true,
      form: {},
      tableData: [],
      customFalge: false,
      formData: {
        isChannel: this.$t('general.Client'),
        circleName: '',
        position: '',
        phone: '',
        email: '',
        province: '',
        city: '',
        salerName: '',
        needType: '0',
        needChoose: [],
        area: '',
        industry: '',
        needProduct: [],
        needNote: ''
      },
      pageData: {
        pageSize: 10,
        pageIndex: 1
      },
      pageTotal: 0,
      editFlage: false,
      clientNameList: [],
      options: [],
      value: [],
      list: [],
      loading: false,
      isChannelList: [this.$t('general.Client'), this.$t('general.Channel'), this.$t('general.media'), this.$t('general.Rjis')],
      entityTypeList: [this.$t('general.pd'), this.$t('general.cp'), this.$t('general.Other')],
      dataFilterMethod: null,
      businessList: [],
      needTypeList: [
        {
          value: '0',
          label: this.$t('general.no')
        },
        {
          value: '1',
          label: this.$t('general.yes')
        },
        {
          value: '2',
          label: this.$t('newApp.Customers.yyz')
        }],
      needChooseList: [],
      areaList: [],
      industryList: [],
      needProductList: [],
      lang: localStorage.getItem('lang') || 'zh-CN',
      loadingdialog: false,
      batchAddDisabled: false,
      customAddDisabled: false,
      inviteSourceList: []
    };
  },
  props: {
    addTraderDialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    salerId: {
      type: String,
      default: ''
    }
  },
  components: {
    commonTable
  },
  watch: {
    addTraderDialogVisible(val) {
      if (val) {
        if (Object.keys(this.rowData).length > 0) {
          this.getActivityLevelList();
          this.formData = {};
          this.formData = JSON.parse(JSON.stringify(this.rowData));
          if (this.formData.needType === 0 || this.formData.needType) {
            const needType = this.formData.needType.toString();
            this.$set(this.formData, 'needType', needType);
          }
          if (isNotEmpty(this.formData.needChoose)) {
            let value = [...new Set(this.rowData.needChoose)];
            this.formData.needChoose = value.map(String);
          }
          if (isNotEmpty(this.needChooseList)) {
            this.needChooseList.forEach(item => {
              item.checked = false;
            });
          }
          if (!isNotEmpty(this.formData.needProduct)) {
            this.formData.needProduct = [];
          } else {
            this.formData.needProduct = this.formData.needProduct.split(',');
          }
          if (this.formData.needChoose) {
            this.needChooseList.forEach(item => {
              const index = this.formData.needChoose.findIndex(ite => item.needId === ite);
              if (index !== -1) {
                item.checked = true;
              }
            });
          } else {
            this.formData.needChoose = [];
          }
          let required = false;
          if (this.formData.needType === '2') {
            required = true;
          } else {
            required = false;
          }
          this.rules.area[0].required = required;
          this.rules.industry[0].required = required;
          this.rules.needProduct[0].required = required;
          this.rules.needNote[0].required = required;
          this.getBusinessName(this.rowData.clientCode);
          this.modeSwitch = false;
          this.editFlage = true;
        } else {
          this.loadTable();
        }
      } else {
        // 关闭弹框初始化数据
        this.formData = {
          isChannel: this.$t('general.Client'),
          circleName: '',
          position: '',
          phone: '',
          email: '',
          industry: '',
          province: '',
          city: '',
          salerName: '',
          needChoose: [],
          needType: '0'
        };
        this.form = {};
        this.modeSwitch = true; // 批量添加 单个添加切换标识
        this.customFalge = false; // 自定义按钮显隐标识
        this.tableData = [];
        this.editFlage = false; // 取消按钮显隐标识
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    getInviteSourceList () {
      const params = ['invite_source'];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          this.inviteSourceList = res.data.invite_source;
        }
      });
    },
    getActivityLevelList() {
      let params = [
        'CRM_AREA',
        'crm_industry',
        'product_need'
      ];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          this.areaList = res.data['CRM_AREA'];
          this.industryList = res.data['crm_industry'];
          this.needProductList = res.data['product_need'];
          console.log(this.formData);
        }
      });
    },
    needTypeChange(e) {
      if (e !== '0') {
        this.getActivityLevelList();
        this.$refs.addTraderForm.clearValidate();
        let required = false;
        if (e === '2') {
          required = true;
        } else {
          required = false;
        }
        this.rules.area[0].required = required;
        this.rules.industry[0].required = required;
        this.rules.needProduct[0].required = required;
        this.rules.needNote[0].required = required;
      }
    },
    getNeedChooseListCommand() {
      this.needChooseList = [];
      travellingTrader.getNeedChooseList().then(res => {
        if (res.status === '200') {
          if (isNotEmpty(res.data)) {
            let resultList = JSON.parse(JSON.stringify(res.data));
            resultList.forEach(item => {
              if (this.needChooseList.findIndex(ite => ite.need === item.need) === -1) {
                item.checked = false;
                this.needChooseList.push(item);
              }
            });
          }
        }
      });
    },
    getBusinessName(id) {
      if (id) {
        this.businessList = [];
        this.businessChanceLoading = true;
        this.loadTable();
        newApplicationFormApi.getBusinessName(id).then(res => {
          this.businessChanceLoading = false;
          if (res.status === '200') {
            this.businessList = res.data.data;
            this.businessList.forEach(item => {
              this.$set(item, 'opportunityCode', item.opportunityNumber);
              this.$set(item, 'opportunityName', item.name);
            });
            this.loadTable();
          }
        });
      }
    },
    clientNameChange(e) {
      const params = {
        customerName: e,
        checkType: 'LIKE',
        pageSize: 1,
        pageNum: 1,
        tid: 'API_MARKET_CRM_ACCOUNT'
      };
      newApplicationFormApi.getCustomerList(params).then(res => {
        if (res.status === '200') {
          if (isNotEmpty(res.data.data)) {
            this.formData.isOldAccount = res.data.data[0].isOldAccount;
            this.getBusinessName(res.data.data[0].id);
          } else {
            this.businessList = [];
            this.$set(this.formData, 'opportunityName', '');
            this.$set(this.formData, 'opportunityCode', '');
          }
        }
      });
    },
    opportunityNameChange(e) {
      const currentData = this.businessList.find(item => item.opportunityName === e);
      this.$set(this.formData, 'opportunityCode', currentData.opportunityNumber);
    },
    identityChange(val) {
      if (val === this.$t('general.Channel')) {
        this.$set(this.formData, 'circleName', '');
        this.$set(this.formData, 'entityType', '');
        this.$set(this.formData, 'businessChance', '');
      } else {
        this.$set(this.formData, 'coconstructionOrNot', '');
        this.$set(this.formData, 'channelContractType', '');
      }
      this.$nextTick(() => {
        this.$refs.addTraderForm.clearValidate();
      });
    },
    companyQueryBtn() {
      if (this.formData.clientName) {
        window.open(
          `https://www.tianyancha.com/search?key=${this.formData.clientName}`
        );
      } else {
        window.open(`https://www.tianyancha.com`);
      }
    },
    batchAddHandle() {
      this.loadingdialog = true;
      this.batchAddDisabled = true;
      let checkedData = this.$refs.addTraderTable.getCheckboxRecords();
      if (checkedData.length > 0) {
        let params = checkedData.map(item => {
          item.activityCode = this.$route.query.activityCode;
          item.needType = '0';
          item.needChoose = [];
          return item;
        });
        this.verificationCustomerCommand(params);
      } else {
        this.$message.error(this.$t('newApp.Customers.psac'));
        this.loadingdialog = false;
        this.batchAddDisabled = false;
      }
    },
    customCancelHandle() {
      this.modeSwitch = !this.modeSwitch;
    },

    customAddHandle() {
      this.$refs['addTraderForm'].validate(valid => {
        if (valid) {
          this.loadingdialog = true;
          this.customAddDisabled = true;
          // let params = {
          //   tid: 'API_MARKET_CRM_ACCOUNT',
          //   checkType: 'ACCURATE',
          //   customerName: this.formData.clientName,
          //   salerId: this.salerId,
          //   pageSize: 10,
          //   pageNum: 1
          // };
          // newApplicationFormApi.getCustomerList(params).then(res => {
          //   if (res.status === '200') {
          //     let { data } = res.data;
          //     let columnName = '';
          //     if (data && data.length > 0) {
          //       columnName = data[0].columnName;
          //     } else {
          //       columnName = this.formData.isChannel === '渠道' ? '营销系统渠道' : '营销系统客户';
          //     }
          //     this.formData.columnName = columnName;
          //
          //   }
          // });
          this.customAddSub();
        }
      })
    },
    customAddSub() {
      let params = [
        {
          activityCode: this.$route.query.activityCode,
          ...this.formData
        }
      ];
      if (params[0].needProduct.length > 0) {
        params[0].needProduct = this.formData.needProduct.join(',');
      } else {
        params[0].needProduct = '';
      }
      if (!params.needType && parent.needType === '0') {
        params.needChoose = [];
      }
      if (this.editFlage) {
        // 编辑
        travellingTrader.verificationCustomer(params).then(res => {
          this.customAddDisabled = false;
          confirmPrecheck(this, res, {
            originalBizId: this.$route.query.activityCode || ''
          }).then(confirmed => {
            if (!confirmed) {
              this.loadingdialog = false;
              return;
            }
            travellingTrader.setCustomerList(params).then(res => {
              confirmBusiness(this, res).then(passed => {
                if (passed) {
                  this.$emit('addSuccessHandle');
                  this.$message.success(this.$t('general.ModSucc'));
                }
                this.loadingdialog = false;
              });
            }).catch(() => {
              this.loadingdialog = false;
            });
          });
        }).catch(() => {
          this.loadingdialog = false;
          this.customAddDisabled = false;
          notifyDetectFailed(this);
        });
      } else {
        // 新增
        this.verificationCustomerCommand(params);
      }
    },
    verificationCustomerCommand(params) {
      travellingTrader.verificationCustomer(params).then(res => {
        this.batchAddDisabled = false;
        this.customAddDisabled = false;
        confirmPrecheck(this, res, {
          originalBizId: this.$route.query.activityCode || ''
        }).then(confirmed => {
          if (!confirmed) {
            this.loadingdialog = false;
            return;
          }
          this.customerSubmitCommand(params);
        });
      }).catch(() => {
        this.loadingdialog = false;
        this.batchAddDisabled = false;
        this.customAddDisabled = false;
        notifyDetectFailed(this);
      });
    },
    customerSubmitCommand(params, loading) {
      if (loading === '1') {
        this.$store.commit('setSubPageLoading', true);
      }
      travellingTrader.customerSubmit(params).then(res => {
        if (loading === '1') {
          this.$store.commit('setSubPageLoading', false);
        }
        confirmBusiness(this, res).then(passed => {
          if (passed) {
            this.$emit('addSuccessHandle');
            this.$message.success(this.$t('general.AddSucc'));
          }
          this.loadingdialog = false;
        });
      }).catch(() => {
        this.loadingdialog = false;
      });
    },
    dialogCloseHandle() {
      this.$emit('dialogCloseHandle');
    },
    resetBtn() {
      this.form = {};
    },
    searchBtn() {
      // let params = {
      //   mactJoinCustomer: {
      //     activityCode: this.$route.query.activityCode,
      //     ...this.form
      //   }
      // };
      this.$refs.addTraderTable.pageData.pageNum = 1;
      this.customFalge = true;
      this.clientNameChange(this.form.clientName);
      this.loadTable();
      // this.$refs.addTraderTable.getTableData({ url: '/customer/', params: params });
    },
    switchBtn() {
      this.modeSwitch = false;
      this.$set(this.formData, 'needProduct', []);
    },
    loadTable() {
      let tableRow = new TableRow();
      tableRow.push(new TableColumns()._width('40')._others('checkbox'));
      tableRow.push(
        new TableColumns()
          ._width('140')
          ._title(this.$t('newApp.Customers.CustomerName'))
          ._data('clientName')
      );
      tableRow.push(
        new TableColumns()
          ._width('140')
          ._title(this.$t('newApp.Customers.ci'))
          ._data('isChannel')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.catt'))
          ._width('10%')
          ._data('accountMarked')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>{row.accountMarked || '--'}</div>
              );
            }
          })
      );
      // 业务机会选择
      // tableRow.push(
      //   new TableColumns()
      //     ._width('100')
      //     ._title(this.$t('newApp.Customers.bo'))
      //     ._data('opportunityName')
      //     ._cellType('customSelect')
      //     ._cellData({
      //       options: this.businessList,
      //       loading: this.businessChanceLoading,
      //       optionProps: {
      //         label: 'opportunityName',
      //         value: 'opportunityName'
      //       },
      //       events: {
      //         change: ({ row }) => {
      //           const currentData = this.businessList.find(item => item.opportunityName === row.opportunityName);
      //           row.opportunityCode = currentData.opportunityNumber;
      //         }
      //       }
      //     })
      // );
      // tableRow.push(
      //   new TableColumns()
      //     ._width('100')
      //     ._title(this.$t('newApp.Customers.bo'))
      //     ._data('opportunityName')
      //     ._cellType('customDom')
      //     ._cellData({
      //       formater: ({ row }) => {
      //         // console.log(this.businessList)
      //         return (
      //           <el-select
      //             v-model={row['opportunityCode']}
      //             placeholder={this.$t('newApp.Customers.bo')}
      //             multiple
      //             collapseTags
      //             onChange={(val) => {
      //               {/* 将多选转为字符串 */ }
      //               row.businessChance = row.businessChanceList.join(",")
      //               row.businessChanceCode = this.arrayQuery(val, this.businessList, 'name')?.opportunityNumber || '';
      //               this.$refs.addTraderTable.refreshColumn();
      //             }}
      //             onFocus={() => {
      //               this.businessList = [];
      //               console.log(row)
      //               this.getBusinessName(row.id);
      //             }}
      //           >
      //             {this.businessList?.map(item => {
      //               return <el-option label={item.opportunityName} value={item.opportunityName} />
      //             })}
      //           </el-select>
      //         )
      //       }
      //     })
      // );
      tableRow.push(
        new TableColumns()
          ._width('180')
          ._title(this.$t('newApp.Customers.pdty'))
          ._data('output')
      );
      tableRow.push(
        new TableColumns()
          ._width('140')
          ._title(this.$t('newApp.Customers.cc'))
          ._data('columnName')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.bc'))
          ._data('mustFollowCustomer')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._width('190')
          ._title(this.$t('newApp.Customers.ccd'))
          ._data('isOldAccount')
      );
      tableRow.push(
        new TableColumns()
          ._width('130')
          ._title(this.$t('newApp.Customers.ccon'))
          ._data('name')
      );
      tableRow.push(
        new TableColumns()
          ._width('130')
          ._title(this.$t('newApp.ADList.ContactNumber'))
          ._data('phone')
      );
      tableRow.push(
        new TableColumns()
          ._width('130')
          ._title(this.$t('newApp.Customers.ccat'))
          ._data('entityType')
      );
      tableRow.push(
        new TableColumns()
          ._width('160')
          ._title(this.$t('newApp.Customers.cst'))
          ._data('channelContractType')
      );
      tableRow.push(
        new TableColumns()
          ._width('120')
          ._title(this.$t('newApp.Customers.noc'))
          ._data('circleName')
      );
      tableRow.push(
        new TableColumns()
          ._width('130')
          ._title(this.$t('newApp.Customers.wtb'))
          ._data('coconstructionOrNot')
      );
      tableRow.push(
        new TableColumns()
          ._width('100')
          ._title(this.$t('newApp.ADList.Regional'))
          ._data('bigArea')
      );
      tableRow.push(
        new TableColumns()
          ._width('100')
          ._title(this.$t('newApp.ADList.Area'))
          ._data('area')
      );
      tableRow.push(
        new TableColumns()
          ._width('80')
          ._title(this.$t('newApp.ADList.Industry'))
          ._data('industry')
      );
      tableRow.push(
        new TableColumns()
          ._width('160')
          ._title(this.$t('newApp.BasicInfo.cs'))
          ._data('salerName')
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.addTraderTable.setColumn(column, {
          pageMin: true,
          customEmpty: {
            name: 'customEmpty',
            formater: () => {
              if (
                this.customFalge &&
                this.$refs.addTraderTable &&
                this.$refs.addTraderTable.tableData.dataList.length < 1
              ) {
                return (
                  <div class="customEle">
                    <img src={require('@/assets/images/contentNull.png')} />
                    <div>{this.$t('approvalCenter.PromptMsg6')}</div>
                    <el-button type="primary" onClick={this.switchBtn}>
                      {this.$t('newApp.Customers.ca')}
                    </el-button>
                  </div>
                );
              } else {
                return (
                  <div class="customEle">
                    <img src={require('@/assets/images/contentNull.png')} />
                    <div>{this.$t('approvalCenter.PromptMsg5')}</div>
                  </div>
                );
              }
            }
          }
        });
        let params = {
          mactJoinCustomer: {
            activityCode: this.$route.query.activityCode,
            ...this.form
          }
        };
        this.$refs.addTraderTable.loadTable({
          url: '/customer/',
          listKey: 'data',
          params
        });
      });
    },
    arrayQuery(val, list, findKey) {
      return list.find(item => {
        return item[findKey] === val;
      });
    },
    getCustomerList() {
      let params = {
        mactJoinCustomer: {
          activityCode: this.$route.query.activityCode,
          ...this.form
        },
        pageSize: this.pageData.pageSize,
        pageIndex: this.pageData.pageIndex
      };
      travellingTrader.getCustomerList(params).then(res => {
        if (res.status === '200') {
          if (res.data.data.length < 1) {
            this.customFalge = true;
          }
          this.tableData = res.data.data;
          this.pageTotal = res.data.total;
          this.loadTable();
        }
      });
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        waitingProcessingApi.getUnitList(query).then(res => {
          this.loading = false;
          this.options = res.data.map(item => {
            return { value: `${item}`, label: `${item}` };
          });
        });
      } else {
        this.options = [];
      }
    },
    getClientNameList() {
      waitingProcessingApi.getUnitList().then(res => {
        this.clientNameList = res.data.map(item => {
          return { value: `${item}`, label: `${item}` };
        });
      });
    }
  },
  mounted() {
    this.getInviteSourceList();
    this.getNeedChooseListCommand();
    this.getClientNameList();
    // 表格回显字段处理
    this.dataFilterMethod = list => {
      return list.map(item => {
        let isOldAccount = '--';
        // 当年是否产出字段处理：如果有值则是， 客户身份如果是客户，则值为'--'
        let output = item.output;
        const oldAccountList = [this.$t('general.yes'), this.$t('general.Ocus')];
        const filterList = [null, undefined, 'undefined'];
        if (item.isChannel !== this.$t('general.Channel')) {
          // 客户类别明细字段处理
          if (!filterList.includes(item.isOldAccount)) {
            isOldAccount = oldAccountList.includes(item.isOldAccount) ? this.$t('general.Ocus') : this.$t('general.Ncus');
          } else {
            if (item.columnName === '营销系统客户') {
              isOldAccount = '--';
            } else {
              isOldAccount = this.$t('general.Ncus');
            }
          }
          output = '--';
        }

        return {
          ...item,
          province: '',
          city: '',
          channelContractType:
            item.channelContractType === 'null' ? '' : item.channelContractType,
          coconstructionOrNot:
            item.coconstructionOrNot === 'null' ? '' : item.coconstructionOrNot,
          isChannel: item.isChannel,
          output,
          isOldAccount
        };
      });
    };
  }
};
</script>

<style lang="scss" scoped>
.addTraderDialog {
  .ordinaryMode {
    >.common_search {
      padding: 0;
      border: none;
    }

    .el-row {
      >.el-col {
        >.label {
          width: 120px;
        }

        >.content {
          margin-left: 130px;
        }
      }
    }

    ::v-deep .common_table {
      .customEle {
        padding: 40px;

        >img {
          width: 300px;
          margin-bottom: 10px;
        }

        >div {
          color: #424c57;
        }

        >.el-button {
          margin-top: 10px;
        }
      }
    }
  }

  .customMode {
    >.link {
      color: #14937b;
      padding-bottom: 16px;
      cursor: pointer;

      >img {
        width: 16px;
        margin-right: 6px;
        vertical-align: middle;
      }

      >span {
        vertical-align: middle;
      }
    }
  }
}

::v-deep .el-checkbox-group {
  height: 34px;
  line-height: 34px;
}
</style>
